export const getConsentCategoryIds = () => window.OnetrustActiveGroups;
